import React, { useState } from 'react';
import { Handle, Position } from 'reactflow';
import { FileText, Settings } from 'lucide-react';

const FileNode = ({ data, selected }) => {
  const [showConfig, setShowConfig] = useState(false);
  
  return (
    <>
      <div className={`px-4 py-2 shadow-md rounded-lg bg-orange-500 text-white border-2 ${
        selected ? 'border-orange-300' : 'border-orange-600'
      }`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <FileText className="h-4 w-4" />
            <div className="text-sm font-medium">{data.label}</div>
          </div>
          <button
            onClick={() => setShowConfig(true)}
            className="p-1 hover:bg-orange-600 rounded"
          >
            <Settings className="h-3 w-3" />
          </button>
        </div>
        
        {data.config?.operation && (
          <div className="text-xs mt-1 opacity-90">
            {data.config.operation}: {data.config.format}
          </div>
        )}
        
        <Handle
          type="target"
          position={Position.Top}
          style={{
            background: '#f97316',
            border: '2px solid #ea580c',
          }}
        />
        <Handle
          type="source"
          position={Position.Bottom}
          style={{
            background: '#f97316',
            border: '2px solid #ea580c',
          }}
        />
      </div>

      {showConfig && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96">
            <h3 className="text-lg font-semibold mb-4">Configure File Node</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">File Operation</label>
                <select className="mt-1 w-full border rounded-lg px-3 py-2">
                  <option>Read File</option>
                  <option>Write File</option>
                  <option>Parse Resume</option>
                  <option>Generate Report</option>
                  <option>Convert Format</option>
                  <option>Extract Text</option>
                  <option>Upload to S3</option>
                  <option>Download from URL</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">File Path/URL</label>
                <input 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder="/path/to/file.pdf or https://..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">File Format</label>
                <select className="mt-1 w-full border rounded-lg px-3 py-2">
                  <option>PDF</option>
                  <option>DOCX</option>
                  <option>CSV</option>
                  <option>JSON</option>
                  <option>XML</option>
                  <option>TXT</option>
                  <option>XLSX</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Processing Options</label>
                <textarea 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder="Additional processing parameters..."
                  rows="3"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Output Variable</label>
                <input 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder="Variable name to store file content"
                />
              </div>
            </div>
            <div className="flex justify-end space-x-2 mt-6">
              <button
                onClick={() => setShowConfig(false)}
                className="px-4 py-2 border rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={() => setShowConfig(false)}
                className="px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FileNode;